export class ApplicationDocumentDto {
    id: number;
    applicationId: number;
    documentName: string;
    description: string;
    descriptionOther: string;
    creationDate: Date;
    documentLocation: string;
}